import React from 'react'
import { ReactComponent as SearchIcon } from '../../images/public/header/search.svg'
const Searchbar = ({Filter}) => {
  return (
    <div className='forms_searchbar_container'>
      <input 
      onChange={(e) => {
        Filter(e.target.value);
      }}
      placeholder="Search"
      />
      <div className='forms_searchbar_icon'>
        <SearchIcon />
      </div>
    </div>
  )
}

export default Searchbar
